import { gql } from "@apollo/client";

export const reportProblem = gql`
  mutation reportProblem($problem: AddUserProblemInput!) {
    addUserProblem(problem: $problem) {
      id
    }
  }
`;
